import { useTypedSelector } from "@/store/store";
import {
  useMultiselectedNavTreeNode,
  useSelectedNavTreeNode,
} from "@/components/Canvas/stores/canvasStore";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { TempoElement } from "@/utils/tempoElement";
import { useActiveCanvas } from "@/utils/utils";
import { useMemo } from "react";

export const useSelectedElements = () => {
  const { selectedElement, storyboardIdSelected } = useSelectedNavTreeNode();
  const { multiselectedElements, multiselectedStoryboardIds } =
    useMultiselectedNavTreeNode();
  const treeElementLookup = useCodebaseStore(
    (state) => state.treeElementLookup,
  );

  const elements = multiselectedElements?.length
    ? multiselectedElements
    : [selectedElement];

  const treeElements = elements.map(
    (element) => treeElementLookup[element.codebaseId],
  );

  const storyboardIds = new Set(
    multiselectedStoryboardIds?.length
      ? multiselectedStoryboardIds
      : [storyboardIdSelected],
  );

  const activeCanvas = useActiveCanvas();
  const storyboards =
    activeCanvas?.storyboards?.filter((storyboard) =>
      storyboardIds.has(storyboard.id),
    ) || [];

  return {
    selectedElements: elements.filter(Boolean),
    selectedTreeElements: treeElements.filter(Boolean),
    selectedStoryboards: storyboards.filter(Boolean),
  };
};
